import axiosInstance from '../../../helpers/axiosInstance';

export default {
  getAllPtpApplicants: (qs = '') => axiosInstance().get('applicant/ptp', { params: qs }),
};
